function CardNumber({ label, number, size }) {
  const handleSize = () => {
    switch (size) {
      case "sm":
        return { width: "50px", height: "50px", fontSize: "0.8rem" };
      case "md":
        return { width: "75px", height: "75px", fontSize: "1.2rem" };
      case "lg":
        return { width: "100px", height: "100px", fontSize: "1.6rem" };
      default:
        return { width: "120px", height: "120px", fontSize: "1.8rem" };
    }
  };

  const sizeStyle = handleSize();

  return (
    <div className="d-flex flex-column align-items-center text-center">
      <div
        className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center text-truncate"
        style={{
          ...sizeStyle,
          padding: "5px",
          overflow: "hidden",
          wordBreak: "break-word",
          textAlign: "center",
        }}
      >
        <span
          style={{
            width: "100%",
            fontSize: "inherit",
            whiteSpace: "normal",
            lineHeight: "1.1",
            fontWeight: "bold",
          }}
        >
          {number}
        </span>
      </div>
      <p className="mt-2">{label}</p>
    </div>
  );
}

export default CardNumber;